import http from "../../http-common";

class NewsArticlesRightSideNewsService {
    getNewsArticlesRightSideNewsService(productPath: string) {
        return http.get(`/right-side-section/news-articles?nodeName=${productPath}&topN=2`);
    }
}

export default new NewsArticlesRightSideNewsService();
